import React from 'react'

import { faAnalytics, faGearComplexCode, faKey } from '@fortawesome/pro-regular-svg-icons'

export const getAdminViewSidebarItems = ({ history, isMFAEnabled }) => [
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>dashboard</span>,
    label: 'dashboard',
    selected: true,
    variant: 'primary',
    onClick() {
      history.push('/admin/dashboard')
    },
    _meta: {
      itemActiveRoutes: '/admin/dashboard'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>overview</span>,
    label: 'Overview',
    variant: 'primary',
    onClick() {
      history.push('/admin/overview')
    },
    _meta: {
      itemActiveRoutes: '/admin/overview'
    }
  },
  {
    itemType: 'section',
    label: 'directory'
  },
  {
    icon: faKey,
    label: 'Service Accounts',
    variant: 'primary',
    onClick() {
      history.push('/admin/service-accounts/aws')
    },
    _meta: {
      itemActiveRoutes: '/admin/service-accounts/aws'
    }
  },
  // {
  //   icon: faGearComplexCode,
  //   label: 'Workloads',
  //   variant: 'primary',
  //   onClick() {
  //     history.push('/admin/workloads')
  //   },
  //   _meta: {
  //     itemActiveRoutes: '/admin/workloads'
  //   }
  // },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>person</span>,
    label: 'Users',
    variant: 'primary',
    onClick() {
      history.push('/admin/users')
    },
    _meta: {
      itemActiveRoutes: '/admin/users'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>groups</span>,
    label: 'Groups',
    variant: 'primary',
    onClick() {
      history.push('/admin/groups')
    },
    _meta: {
      itemActiveRoutes: '/admin/groups'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>devices</span>,
    label: 'devices',
    variant: 'primary',
    onClick() {
      history.push('/admin/devices')
    },
    _meta: {
      itemActiveRoutes: '/admin/devices'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>fingerprint</span>,
    label: 'Non-Human Identities',
    variant: 'primary',
    onClick() {
      history.push('/admin/non-human-identities')
    },
    _meta: {
      itemActiveRoutes: '/admin/non-human-identities'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>network_node</span>,
    label: 'gateways',
    variant: 'primary',
    onClick() {
      history.push('/admin/gateways')
    },
    _meta: {
      itemActiveRoutes: '/admin/gateways'
    }
  },

  {
    itemType: 'section',
    label: 'cloud'
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>cloud</span>,
    label: 'clouds',
    variant: 'primary',
    onClick() {
      history.push('/admin/clouds')
    },
    _meta: {
      itemActiveRoutes: '/admin/clouds'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>stacks</span>,
    label: 'Targets',
    variant: 'primary',
    onClick() {
      history.push('/admin/targets')
    },
    _meta: {
      itemActiveRoutes: '/admin/targets'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>domain_verification</span>,
    label: 'Resources',
    variant: 'primary',
    onClick() {
      history.push('/admin/resources')
    },
    _meta: {
      itemActiveRoutes: '/admin/resources'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>engineering</span>,
    label: 'IAM Roles',
    variant: 'primary',
    onClick() {
      history.push('/admin/iam-roles/aws')
    },
    _meta: {
      itemActiveRoutes: '/admin/iam-roles'
    }
  },

  {
    itemType: 'section',
    label: 'Identity analytics',
    _meta: {
      showIDA: true
    }
  },
  {
    icon: faAnalytics,
    label: 'analytics dashboard',
    variant: 'primary',
    onClick() {
      history.push('/admin/idaanalyzer')
    },
    _meta: {
      itemActiveRoutes: '/admin/idaanalyzer',
      showIDA: true
    }
  },
  {
    itemType: 'section',
    label: 'Permission Management'
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>category</span>,
    label: 'SaaS Apps',
    variant: 'primary',
    onClick() {
      history.push('/admin/saas-apps')
    },
    _meta: {
      itemActiveRoutes: '/admin/saas-apps'
    }
  },
  {
    itemType: 'section',
    label: 'AI Security'
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>cognition</span>,
    label: 'Agentic Apps',
    variant: 'primary',
    onClick() {
      history.push('/admin/agentic-apps')
    },
    _meta: {
      itemActiveRoutes: '/admin/agentic-apps'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>precision_manufacturing</span>,
    label: 'Agent Registry',
    variant: 'primary',
    onClick() {
      history.push('/admin/agent-config')
    },
    _meta: {
      itemActiveRoutes: '/admin/agent-config'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>cloud_done</span>,
    label: 'Workload Agents',
    variant: 'primary',
    onClick() {
      history.push('/admin/workload-agents')
    },
    _meta: {
      itemActiveRoutes: '/admin/workload-agents',
      showShadowAI: true
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>policy</span>,
    label: 'Personal Agents',
    variant: 'primary',
    onClick() {
      history.push('/admin/personal-agents')
    },
    _meta: {
      itemActiveRoutes: '/admin/personal-agents',
      showShadowAI: true
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>deployed_code</span>,
    label: 'NHI Agents',
    variant: 'primary',
    onClick() {
      history.push('/admin/nhi-agents')
    },
    _meta: {
      itemActiveRoutes: '/admin/nhi-agents',
      showShadowAI: true
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>target</span>,
    label: 'Intents',
    variant: 'primary',
    onClick() {
      history.push('/admin/ai-intents')
    },
    _meta: {
      itemActiveRoutes: '/admin/ai-intents'
    }
  },
  {
    itemType: 'section',
    label: 'Secrets'
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>encrypted</span>,
    label: 'Hubs',
    variant: 'primary',
    onClick() {
      history.push('/admin/secrets/hub')
    },
    _meta: {
      itemActiveRoutes: '/admin/secrets'
    }
  },
  {
    itemType: 'section',
    label: 'Access Management'
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>psychology_alt</span>,
    label: 'Access Requests',
    variant: 'primary',
    onClick() {
      history.push('/admin/access-requests')
    },
    _meta: {
      itemActiveRoutes: '/admin/access-requests'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>front_hand</span>,
    label: 'HITL Requests',
    variant: 'primary',
    onClick() {
      history.push('/admin/agent-approvals')
    },
    _meta: {
      itemActiveRoutes: '/admin/agent-approvals'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>assignment_turned_in</span>,
    label: 'Access Policies',
    variant: 'primary',
    onClick() {
      history.push('/admin/policys')
    },
    _meta: {
      itemActiveRoutes: '/admin/policys'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>deployed_code</span>,
    label: 'Bundles',
    variant: 'primary',
    onClick() {
      history.push('/admin/bundles')
    },
    _meta: {
      itemActiveRoutes: '/admin/bundles'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>gavel</span>,
    label: 'AI Policies',
    variant: 'primary',
    onClick() {
      history.push('/admin/ai-policys')
    },
    _meta: {
      itemActiveRoutes: '/admin/ai-policys'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>sell</span>,
    label: 'Tag Policies',
    variant: 'primary',
    onClick() {
      history.push('/admin/tags')
    },
    _meta: {
      itemActiveRoutes: '/admin/tags'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>approval</span>,
    label: 'Approver Policies',
    variant: 'primary',
    onClick() {
      history.push('/admin/approver-policies')
    },
    _meta: {
      itemActiveRoutes: '/admin/approver-policies'
    }
  },
  {
    itemType: 'section',
    label: 'Activity'
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>query_stats</span>,
    label: 'Agent Insights',
    variant: 'primary',
    onClick() {
      history.push('/admin/agent-insights')
    },
    _meta: {
      itemActiveRoutes: '/admin/agent-insights'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>vital_signs</span>,
    label: 'activity logs',
    variant: 'primary',
    onClick() {
      history.push('/admin/activity-logs')
    },
    _meta: {
      itemActiveRoutes: '/admin/activity-logs'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>show_chart</span>,
    label: 'Session Logs',
    variant: 'primary',
    onClick() {
      history.push('/admin/session-logs')
    },
    _meta: {
      itemActiveRoutes: '/admin/session-logs'
    }
  },
  {
    itemType: 'section',
    label: 'Connections'
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>plug_connect</span>,
    label: 'integrations',
    variant: 'primary',
    onClick() {
      history.push('/admin/integrations')
    },
    _meta: {
      itemActiveRoutes: '/admin/integrations'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>lan</span>,
    label: 'RDP User Management',
    variant: 'primary',
    onClick() {
      history.push('/admin/addomaincontrollers')
    },
    _meta: {
      itemActiveRoutes: '/admin/addomaincontrollers'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>dns</span>,
    label: 'Server Management',
    variant: 'primary',
    onClick() {
      history.push('/admin/server-controllers')
    },
    _meta: {
      itemActiveRoutes: '/admin/server-controllers'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>device_hub</span>,
    label: 'Proxy Management',
    variant: 'primary',
    onClick() {
      history.push('/admin/proxy-controllers')
    },
    _meta: {
      itemActiveRoutes: '/admin/proxy-controllers'
    }
  }
]
